export default "__VITE_ASSET__D0PoqOIb__"